/**
 * Generated by orval 🍺
 * Do not edit manually.
 * parktool API
 * Share a few Q-Park parking spots: users register plates and book days, the backend puts the right plate on each spot.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import { customFetch } from '../../fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getOpenGateUrl = () => {




  return `/api/gate/open`
}

/**
 * @summary Calls the gate and presses 9. Takes a few seconds; returns once the digit was sent.
 */
export const openGate = async ( options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getOpenGateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOpenGateMutationKey = () => ['openGate'] as const;

export const getOpenGateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openGate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof openGate>>, TError,void, TContext> => {

const mutationKey = getOpenGateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openGate>>, void> = () => {


          return  openGate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenGateMutationResult = NonNullable<Awaited<ReturnType<typeof openGate>>>

    export type OpenGateMutationError = void


    /**
 * @summary Calls the gate and presses 9. Takes a few seconds; returns once the digit was sent.
 */
export const useOpenGate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openGate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openGate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getOpenGateMutationOptions(options), queryClient);
    }
